import React from "react";
import styles from "../style/announcement.module.css";

function getRightIcon() {
    return (
        <svg
            width="6"
            height="11"
            viewBox="0 0 6 11"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={styles.announcement_right_icon}
        >
            <path
                d="M5.37318 4.82145C5.72711 5.20459 5.72711 5.79541 5.37318 6.17855L1.73455 10.1175C1.11698 10.786 -6.29574e-08 10.3491 -2.31744e-08 9.43893L3.21178e-07 1.56107C3.60961e-07 0.650938 1.11698 0.213979 1.73455 0.882518L5.37318 4.82145Z"
                fill="white"
            />
        </svg>
    );
}
function getStarIcon() {
    return (
        <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={styles.announcement_star}
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M5.11176 0.00238022C5.10481 0.0258104 5.08389 0.126454 5.06528 0.226032C5.03213 0.403249 4.93079 0.898435 4.87559 1.15289C4.7325 1.81272 4.50394 2.51531 4.29363 2.9418C3.99227 3.55297 3.51152 4.04266 2.91409 4.34693C2.31402 4.65256 1.45613 4.90768 0.297826 5.1249C0.159203 5.1509 0.0333702 5.17589 0.0182056 5.18042C-0.0214911 5.19229 0.0091531 5.23157 0.0580914 5.23157C0.0808173 5.23157 0.243301 5.26062 0.419164 5.29613C1.88675 5.59243 2.67024 5.85964 3.28825 6.27468C3.67087 6.53164 4.06364 6.9939 4.29317 7.45743C4.50305 7.88126 4.73216 8.58498 4.87559 9.24635C4.93632 9.52627 5.03356 10.0024 5.06708 10.1839C5.08655 10.2893 5.10863 10.3873 5.11611 10.4016C5.12361 10.416 5.15156 10.3106 5.17821 10.1673C5.51658 8.35031 5.86581 7.38938 6.41904 6.75301C6.49978 6.66012 6.57802 6.57448 6.59287 6.5627C6.60774 6.55092 6.67188 6.49728 6.73542 6.44352C7.0456 6.181 7.4453 5.96553 7.97463 5.77549C8.17876 5.70219 8.43641 5.61963 8.53122 5.59712C8.57743 5.58613 8.70975 5.5516 8.82527 5.52037C8.94079 5.48915 9.12037 5.44553 9.22434 5.42346C9.32831 5.40139 9.52207 5.35996 9.65491 5.33144C9.78776 5.3029 9.96734 5.26765 10.054 5.25312C10.1406 5.2386 10.2256 5.21898 10.2427 5.2095C10.2791 5.18946 10.2924 5.19299 9.88595 5.1148C7.5061 4.65693 6.5399 4.1249 5.95894 2.95245C5.66182 2.35285 5.47189 1.70426 5.21348 0.407083C5.16179 0.147583 5.11909 -0.0223279 5.11176 0.00238022ZM10.7311 7.46808C10.7177 7.53251 10.6741 7.74339 10.6343 7.93669C10.3239 9.44241 9.93285 9.9806 8.88828 10.3396C8.55139 10.4554 8.32623 10.5126 7.8171 10.6116C7.72469 10.6296 7.61127 10.6548 7.56506 10.6677L7.48104 10.6911L7.55456 10.7086C7.59499 10.7182 7.76984 10.7555 7.94312 10.7914C9.42171 11.0983 9.98097 11.4669 10.3342 12.3671C10.46 12.6876 10.5644 13.0796 10.6824 13.6744C10.717 13.8486 10.7491 13.9951 10.7538 13.9998C10.7585 14.0046 10.7831 13.9052 10.8084 13.7789C10.8945 13.3496 10.9204 13.23 10.9714 13.0274C11.1463 12.3324 11.3464 11.9142 11.6531 11.6032C12.0257 11.2254 12.5486 11.004 13.5721 10.7911C14.0936 10.6826 14.0573 10.6979 13.8871 10.6578C13.8063 10.6387 13.6409 10.6023 13.5196 10.5769C12.8946 10.446 12.5367 10.3338 12.1858 10.1585C11.9528 10.0421 11.8201 9.94476 11.6398 9.7581C11.3382 9.44595 11.1779 9.11124 10.9715 8.36269C10.9537 8.29826 10.9041 8.07301 10.8612 7.86213C10.8183 7.65126 10.777 7.44998 10.7693 7.41483C10.7564 7.35549 10.7537 7.3593 10.7311 7.46808Z"
                fill="white"
            />
        </svg>
    );
}

type AnnouncementProps = {
    heading: string;
    text: string;
    link: string;
};
export default function Announcement({ heading, text, link }: AnnouncementProps) {
    return (
        <div className="announcement_wrapper">
            <div className="announcement_offset"></div>
            <div className="announcement_container">
                <div className="announcement_topic_container">
                    {/* {getStarIcon()} */}
                    <span className="announcement_topic">{heading}</span>
                </div>

                <a href={link} className="announcement_link">
                    <span className="announcement_text">{text}</span>
                    {getRightIcon()}
                </a>
            </div>
        </div>
    );
}
